export enum SpUserFields {
  CP_LISTE_EXTID_CARAC = 'CP_LISTEEXTIDCARAC'
}
